module.exports = __webpack_public_path__ + "static/media/cta.bbf2c25d.png";